import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
import { ZapIcon, ShieldCheckIcon, DownloadIcon, BanIcon } from 'lucide-react';
import { useCurrencyByIP } from '../../hooks/useCurrencyByIP';
export function PricingSection() {
  const {
    price,
    originalPrice,
    isLoading
  } = useCurrencyByIP();
  return <section id="pricing" className="w-full py-24 md:py-36 px-4 md:px-5" data-id="element-275">
      <div className="max-w-3xl mx-auto" data-id="element-276">
        {/* Headline */}
        <ScrollReveal data-id="element-277">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-5" data-id="element-278">
            Tu contenido cambia cuando dominas{' '}
            <span className="text-accent" data-id="element-279">el primer segundo.</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.08} data-id="element-280">
          <div className="text-center mb-10 md:mb-14 max-w-2xl mx-auto space-y-3" data-id="element-281">
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed" data-id="element-282">
              No necesitas más ideas.{' '}
              <span className="text-white font-semibold" data-id="element-283">
                Necesitas mejores inicios.
              </span>
            </p>
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed" data-id="element-284">
              Hook Arsenal te da exactamente eso.
            </p>
            <p className="text-lg md:text-xl text-white font-bold" data-id="element-285">
              200 ganchos listos para usar.
            </p>
          </div>
        </ScrollReveal>

        {/* Benefit list */}
        <ScrollReveal delay={0.12} data-id="element-286">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-14 md:mb-18" data-id="element-287">
            <span className="text-sm md:text-base text-neutral-300" data-id="element-288">
              ✓ Más retención
            </span>
            <span className="text-sm md:text-base text-neutral-300" data-id="element-289">
              ✓ Más seguidores
            </span>
            <span className="text-sm md:text-base text-neutral-300" data-id="element-290">
              ✓ Más ventas
            </span>
            <span className="text-sm md:text-base text-neutral-300" data-id="element-291">
              ✓ Sin improvisar
            </span>
          </div>
        </ScrollReveal>

        {/* Price box */}
        <ScrollReveal delay={0.18} data-id="element-292">
          <div className="relative max-w-md mx-auto bg-surface border border-accent/20 rounded-3xl p-8 md:p-10 text-center overflow-hidden" data-id="element-293">
            {/* Glow */}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at top center, rgba(255,107,0,0.07) 0%, transparent 60%)'
          }} data-id="element-294" />

            <div className="relative" data-id="element-295">
              {/* Label */}
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-296">
                <ZapIcon className="w-5 h-5 text-accent" data-id="element-297" />
                <span className="text-sm font-bold tracking-widest uppercase text-accent" data-id="element-298">
                  Hook Arsenal
                </span>
              </div>
              <p className="text-neutral-400 text-sm mb-1" data-id="element-299">Acceso completo</p>
              <p className="text-neutral-500 text-xs mb-6" data-id="element-300">Pago único</p>

              {/* Pricing */}
              <div className="mb-3" data-id="element-301">
                <span className="text-neutral-400 text-sm mr-2" data-id="element-302">Antes:</span>
                <span className="text-2xl text-neutral-400 line-through font-bold" data-id="element-303">
                  {originalPrice}
                </span>
              </div>
              <div className="mb-1" data-id="element-304">
                <span className="text-sm text-accent font-semibold" data-id="element-305">
                  🔥 Super Promo:{' '}
                </span>
                <span className={`text-5xl md:text-6xl font-extrabold text-accent transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`} data-id="element-306">
                  {price}
                </span>
              </div>
              <p className="text-xs text-amber-400/70 font-medium mb-6" data-id="element-307">
                Solo por esta semana
              </p>

              {/* CTA — dominant */}
              <CTAButton className="mx-auto text-xl md:text-2xl py-5 md:py-6 px-10 md:px-14 w-full" data-id="element-308">
                Acceder a los 200 ganchos — {price}
              </CTAButton>
            </div>
          </div>
        </ScrollReveal>

        {/* Security badges */}
        <ScrollReveal delay={0.25} data-id="element-309">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-6 text-neutral-500 text-xs" data-id="element-310">
            <div className="flex items-center gap-1.5" data-id="element-311">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-312" />
              <span data-id="element-313">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-314">
              <DownloadIcon className="w-3.5 h-3.5" data-id="element-315" />
              <span data-id="element-316">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-317">
              <BanIcon className="w-3.5 h-3.5" data-id="element-318" />
              <span data-id="element-319">Sin suscripciones</span>
            </div>
          </div>
        </ScrollReveal>

        {/* Urgency */}
        <ScrollReveal delay={0.3} data-id="element-320">
          <p className="text-center text-xs text-amber-500/70 font-medium mt-6" data-id="element-321">
            ⚡ El precio puede subir en cualquier momento.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}